<template>
  <div>
    <v-btn @click="logInWithFacebook" class="mt-3" color="primary" ><v-icon>mdi-facebook</v-icon> Connect Facebook</v-btn>
  </div>
</template>
<script>
  export default {
    name:"facebookLogin",
    props: {
      appId: {
        type: String,
        default: ()=>{
          return ''
        }
      },
      appSecret: {
        type: String,
        default: ()=>{
          return ''
        }
      },
    },
    async mounted() {

      await this.loadFacebookSDK(document, "script", "facebook-jssdk");

    },
    methods: {
      async logInWithFacebook() {
        await this.initFacebook();
        window.FB.login((response)=>{
          if (response.authResponse) {
          this.loadPages(response.authResponse.accessToken)
          } else {

          }
        },{scope: 'pages_show_list, pages_messaging, pages_manage_metadata, pages_messaging_subscriptions'});
        return false;
      },
      async loadPages(token) {
        this.$http_facebook_auto_provision.post('/api/pages',{
          token
        })
        .then(response=>{
          this.$emit('setFacebookPages', response.data.payload.data)
        })
        .catch(error=>{

        })
      },
      async initFacebook() {
        let appId = this.appId
          window.FB.init({
            appId: appId,
            cookie: true,
            version: "v13.0"
          });
      },
      async loadFacebookSDK(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }
    },
    watch: {
      appId (){
        if (this.appId) {

        }
      }
    }
  };
</script>
<style>
  .button{
    color:white;
    min-width: 150px;
    background-color: #000000a1;
    height: 2.5rem;
    border-radius: 2rem;
    font-weight: 400;
    font-size: 0.8rem;
  }
</style>
